import { NavLink, Outlet } from 'react-router-dom';
import './portfolio.css';

const primaryRoutes = [
  ['Work', '/work'],
  ['Art', '/art'],
  ['Lab', '/lab'],
  ['About', '/about'],
];

function PortfolioLayout() {
  return (
    <div className="portfolio-shell">
      <a className="portfolio-skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="portfolio-header">
        <NavLink className="portfolio-brand" to="/" aria-label="CVAD home">
          CVAD
        </NavLink>
        <nav className="portfolio-nav" aria-label="Primary navigation">
          {primaryRoutes.map(([label, path]) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                isActive ? 'portfolio-nav__link is-active' : 'portfolio-nav__link'
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="portfolio-header__actions">
          <NavLink className="portfolio-text-link" to="/resume">Résumé</NavLink>
          <NavLink className="portfolio-button portfolio-button--small" to="/contact">Contact</NavLink>
        </div>
      </header>
      <Outlet />
      <footer className="portfolio-footer">
        <p>Charles Van Alst Danner — Product engineering leadership for web, mobile, and media technology.</p>
        <div className="portfolio-footer__links">
          <NavLink to="/work">Work</NavLink>
          <NavLink to="/resume">Résumé</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </div>
      </footer>
    </div>
  );
}

export default PortfolioLayout;
